import {AxiosInstance} from "axios";
import {Program, ProgramInclusion, ProgramInclusionGroup, ProgramSnapshot} from "@/program/interfaces/Program";

export default function (client: AxiosInstance) {
    return {
        /**
         * Get programs for a given consumer.
         *
         * @param consumerKey The consumer key.
         *
         * @return {*}
         */
        async index(consumerKey: string): Promise<Program[]> {
            const response = await client.get(`consumers/${consumerKey}/programs`);

            return response.data.data;
        },

        /**
         * Get programs snapshot for a given consumer.
         *
         * @param consumerKey The consumer key.
         *
         * @return {*}
         */
        async snapshot(consumerKey: string): Promise<ProgramSnapshot[]> {
            const response = await client.get(`consumers/${consumerKey}/snapshot`);

            return response.data.data;
        },

        /**
         * Refresh the program for a given consumer.
         */
        async refresh(consumerKey: string, programId: number): Promise<Program[]> {
            const response = await client.patch(`consumers/${consumerKey}/programs/${programId}/refresh`);

            return response.data.data;
        },

        /**
         * List available groups for a given program.
         *
         * @param programId
         */
        async groups(programId: number): Promise<ProgramInclusionGroup[]> {
            const response = await client.get(`programs/${programId}/inclusion-groups`);

            return response.data.data;
        },

        /**
         * Manually include a consumer in a given program.
         * @param consumerKey  The consumer key.
         * @param programId  The program id.
         * @param group  The targeting group name.
         * @param comments  The optional comments.
         */
        async include(
            programId: number,
            consumerKey: string,
            group: string | null = null,
            comments: string | null = null
        ): Promise<ProgramInclusion> {
            const response = await client.post(`programs/${programId}/inclusions`, {
                consumer_key: consumerKey,
                group,
                operation: 'in',
                comments
            });

            return response.data.data;
        },

        /**
         * Delete a manual inclusion.
         */
        async deleteInclusion(programId: number, inclusionId: number,): Promise<{deleted: boolean}> {
            const response = await client.delete(`programs/${programId}/inclusions/${inclusionId}`);

            return response.data.data;
        }
    };
}
